import { Component, ElementRef, Injector, NgZone, OnInit, QueryList, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { TrovaAtmService } from './trova-atm.service';
import { ResponseError } from 'app/shared/service/api-service/api-service';
import { NgForm } from '@angular/forms';
import { Utils } from 'app/shared/utility/utils';
import { PagerService } from 'app/shared/service/pagination-service/pagination-service';
import { ModalService } from 'app/modal/modal.service';
import { LabelIT } from 'app/shared/models/labelsIT.model';
import { CmsService } from './shared/service/cms/cms.service';
import { GoogleMap, MapMarker } from '@angular/google-maps';

@Component({
  selector: 'app-trova-atm',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [CmsService]
})

export class TrovaAtmComponent implements OnInit { //extends CmsPageBaseComponent

  /**
   * For displaying the map in the page
   */
  latitude: number;
  longitude: number;
  latlngBounds: any;
  icon: any;
  iconActive: any;

  /**
   * Array containing the custom styling for the map to be displayed
   */
  customMapStyle: any[];

  /**
   * number to set zoom level of map
   */
  zoomLevel: number;

  /**
   * Tab Display
   */
  agenzieTabLabel: string;
  atmTabLabel: string;
  listATMEmpty = false;

  /**
   * Title bar display
   */
  titleBarTitle: string;
  titleBarSubtitle: string;
  titleBarMenuTitle: string;
  titleBarMenuItems: any[];

  /**
   * Labels
   */
  agenzieHeader: string;
  atmHeader: string;
  provinceHeader: string;
  searchButtonLabel: string;
  regionSelectLabel: string;
  provinceSelectLabel: string;
  oldRegion: any = "";
  getCurrentLocationLabel: string;
  resultsFoundLabel: string;
  agencyResultTitle: string;
  atmResultTitle: string;
  detailButtonLabel: string;
  goBackLabel: string;
  lookOnGoogleMapLabel: string;
  serviceLabel: string;
  filterByServiceLabel: string;
  filterLabel: string;
  regioniProvinceResponse;
  showAgenciesTab: boolean;
  geoLocatedRegion: any = "";
  geoLocatedCity: any = "";

  /**
   * Messages
   */
  valueRequiredMessage: string;

  /**
   * Drop down contents
   */
  regionList: { value: string, label: string, name: string }[] = [];
  provinceList: { value: string, label: string }[] = [];

  /**
   * Error message when service call fails
   */
  serviceErrorMessage: string;

  /**
   * Store rregion, province, current location, search results
   */
  atmProvince: string;
  atmRegion: string;
  agencyRegion: string;
  currentLocation: { lattitude: number, longitude: number };
  atmList: any //{name: string, latitude: number, longitude: number, shortAddress: string, services: string []} [] = [];
  filteredAtmList: any //{name: string, latitude: number, longitude: number, shortAddress: string, services: string []} [] = [];
  agencyList: { name: string, latitude: number, longitude: number, shortAddress: string }[] = [];
  totalAgenciesFound: number;
  totalATMsFound: number;
  protected map: any;

  /**
   * object of an atm detail
   */
  atmDetail: any;

  /**
   * object of an agency detail
   */
  agencyDetail: { name: string, latitude: number, longitude: number, shortAddress: string } = {
    name: "",
    latitude: null,
    longitude: null,
    shortAddress: ""
  };

  /**
   * Flags, used for handling the spinner during the services calls
   */
  busyCard: boolean;
  busyCardReverseGeocoding: boolean;
  busyCardATMByPosition: boolean;

  /**
   * Flags, which are used to manipulate DOM
   */
  showAgencyMarkers: boolean;
  showAtmMarkers: boolean;
  showAgencyDetail: boolean;
  showAtmDetail: boolean;
  showAgencyGrid: boolean;
  showAgencyList: boolean;
  showAtmList: boolean;
  showAtmGrid: boolean;
  cardRicerca: any;

  isWeb: boolean;
  isMobile: boolean;
  language: string;
  labels: any;

  /**
   * variables to manage the table/grid pagination
   */
  tsHistoryTransaction: any[];
  paginationContext: any[];
  pager: PagerService = new PagerService();   // Pager object for pagination
  displayList: any[];
  displayGrid: any[];

  /**
   * Store checkbox values on filter page
   */
  services: { filter: boolean, label: string }[] = [];

  // Env
  currentEnvironment: string;

  // Functions
  private readonly closeSelectFromParent;
  LABEL_TEXT = 'labels.text.fill';
    // google script
    matOptions: google.maps.MapOptions = {
      backgroundColor: '#e5e3df',
      streetViewControl: false,
      fullscreenControl: false,
      mapTypeControl: false,
      zoomControl: true,
      disableDefaultUI: true,
      scrollwheel: false,
      gestureHandling: 'cooperative',
      styles: [
        {
          featureType: 'all',
          elementType: 'geometry',
          stylers: [
          { "visibility": "on" },
          { "hue": "#00a24d" },
          { "saturation": -50 },
          { "lightness": 20 },
          { "gamma": 1.06 }]
      
        },
        {
          featureType: 'administrative.locality',
          elementType: this.LABEL_TEXT,
          stylers: [{ "color": "#5f5f5f" },]
        },
        {
          featureType: 'administrative.country',
          elementType: this.LABEL_TEXT,
          stylers: [{ "color": "#474a51" },]
        },
        {
          featureType: 'water',
          elementType: this.LABEL_TEXT,
          stylers: [{ "color": "#00a24d" },]
      
        }
      ]
    };
  
    multiMarkerOptions: google.maps.MarkerOptions = {
      icon : {
        url: './assets/res/img/map-marker.png',
        scaledSize: new google.maps.Size(32,41)
        }
      };
     
    singleMarkerOptions: google.maps.MarkerOptions = {
      icon : {
        url: './assets/res/img/map-marker-active.png',
        scaledSize: new google.maps.Size(32,41)
        }
      };
  

  /**
   * Reference to forms
   */
  @ViewChild("agencyForm", {static: false}) agencyForm: NgForm;
  @ViewChild("atmForm", {static: false}) atmForm: NgForm;
  @ViewChild('filterForm', {static: false}) filterForm: NgForm;
  @ViewChild(GoogleMap) mappa!: GoogleMap;
  @ViewChildren(MapMarker) markers!: QueryList<MapMarker>;
  atmRegionName: string;
  printProvince: string;

  constructor(
    private readonly modalService: ModalService,
    protected inj: Injector,
    private readonly ngZone: NgZone,
    protected trovaAtmService: TrovaAtmService,
    private readonly ref: ElementRef,
    public cmsService: CmsService
  ) {
    this.closeSelectFromParent = function (event) {

      const trustedDomain = event.origin;

      if(this.ref && trustedDomain === location.origin) {
        // chiusura select
        const select = this.ref.nativeElement.querySelector('.select-atm .is-open');
        const overlay = this.ref.nativeElement.querySelector('.bh-bg');
        const selectVisible = this.ref.nativeElement.querySelector('.select-atm .is-visible');

        select.classList.remove('is-open');
        overlay.classList.remove('showOverlay');
        selectVisible.classList.remove('is-visible');
      }
    }
    // CR 453: get postMessage from parent
    window.addEventListener("message", this.closeSelectFromParent);

    this.initPage();
  }

  /**
   * Life cycle method
   * Automatically called once during the loading of the page
   */
  ngOnInit() {
    // [BCD-1116] Eliminata chiamata tracciamento pageview
    // this.cmsService.trackNEW("pageview");

    // Map options
    this.customMapStyle = [{
      "stylers": [
        { "visibility": "on" },
        { "hue": "#00a24d" },
        { "saturation": -50 },
        { "lightness": 20 },
        { "gamma": 1.06 }]
    }];

    this.icon = {
      url: './assets/res/img/map-marker.png',
      scaledSize: {
        width: 32,
        height: 41
      }
    };

    this.iconActive = {
      url: './assets/res/img/map-marker-active.png',
      scaledSize: {
        width: 32,
        height: 41
      }
    };

    this.latitude = 43.769562;
    this.longitude = 11.255814;
    this.zoomLevel = 7;

    // rimuovere il flag appena si riattivano le agencies
    this.showAgenciesTab = false;
    this.fillRegionList();
  }

  initPage() {
    this.language = 'IT';
    if('IT' === this.language) {
      this.labels = LabelIT;
    }

    this.atmTabLabel = this.labels.getLabel('TROVA_ATM', 'atmTabLabel');
    this.agenzieTabLabel = this.labels.getLabel('TROVA_ATM', 'agenzieTabLabel');
    this.titleBarTitle = this.labels.getLabel('TROVA_ATM', 'titleBarTitle');
    this.titleBarSubtitle = this.labels.getLabel('TROVA_ATM', 'titleBarSubtitle');
    this.titleBarMenuTitle = this.labels.getLabel('TROVA_ATM', 'titleBarMenuTitle');
    this.agenzieHeader = this.labels.getLabel('TROVA_ATM', 'agenzieHeader');
    this.atmHeader = this.labels.getLabel('TROVA_ATM', 'atmHeader');
    this.provinceHeader = this.labels.getLabel('TROVA_ATM', 'provinceHeader');
    this.regionSelectLabel = this.labels.getLabel('TROVA_ATM', 'regionSelectLabel');
    this.provinceSelectLabel = this.labels.getLabel('TROVA_ATM', 'provinceSelectLabel');
    this.searchButtonLabel = this.labels.getLabel('TROVA_ATM', 'searchButtonLabel');
    this.getCurrentLocationLabel = this.labels.getLabel('TROVA_ATM', 'getCurrentLocationLabel');
    this.resultsFoundLabel = this.labels.getLabel('TROVA_ATM', 'resultsFoundLabel');
    this.agencyResultTitle = this.labels.getLabel('TROVA_ATM', 'agencyResultTitle');
    this.detailButtonLabel = this.labels.getLabel('TROVA_ATM', 'detailButtonLabel');
    this.goBackLabel = this.labels.getLabel('TROVA_ATM', 'goBackLabel');
    this.lookOnGoogleMapLabel = this.labels.getLabel('TROVA_ATM', 'lookOnGoogleMapLabel');
    this.atmResultTitle = this.labels.getLabel('TROVA_ATM', 'atmResultTitle');
    this.serviceLabel = this.labels.getLabel('TROVA_ATM', 'serviceLabel');
    this.filterByServiceLabel = this.labels.getLabel('TROVA_ATM', 'filterByServiceLabel');
    this.filterLabel = this.labels.getLabel('TROVA_ATM', 'filterLabel');
    this.valueRequiredMessage = this.labels.getLabel('TROVA_ATM', 'valueRequiredMessage');

    // from 1 to 8
    for(let i=1; i<8; i++) {
      this.services.push({
        'filter': false,
        'label': this.labels.getLabel('TROVA_ATM', `service${i}Label`)
      });
    }
  }

  protected onFormChange(id: any, value: any) {}

  setDirtyProvince() {
    this.atmForm.form.controls['atmProvince'].markAsTouched();
  }

  activateBlur(data: any) {
    var overlay = this.ref.nativeElement.querySelector('.bh-bg');

    overlay.classList.remove('showOverlay');
    overlay.classList.add('hideOverlay');
  }

  activateFocus(data: any) {
    var overlay = this.ref.nativeElement.querySelector('.bh-bg');
    //COMMENTO var containerSelect = document.querySelector('.fnd‐mdl‐dynamic‐textfield')
    overlay.classList.add('showOverlay');
  }

  /**
   * Used to populate data for province dropdown
   * @param data - region code
   */
  fillProvinceList(data: any, fromRegionSelected = false) {
    this.regionSelectLabel = "";
    this.busyCard = true;
    this.serviceErrorMessage = undefined;
    this.provinceList = [];

    this.atmForm.form.controls['atmProvince'].reset();
    this.atmForm.form.controls['atmProvince'].setValue("");
    this.provinceSelectLabel = this.labels.getLabel('TROVA_ATM', 'provinceSelectLabel');

    const provinceArray = this.regioniProvinceResponse.data.regions
      .filter((region) => {
        return region.code === data;
      });

    var province = "";
    if(provinceArray.length > 0) {
      province = provinceArray[0].province;
    }

    if(province !== undefined) {
      Object.keys(province).forEach((key) => {
        this.provinceList.push({ value: province[key].acronym, label: province[key].description });
      });

      this.provinceList.unshift({ value: "Seleziona", label: this.labels.getLabel('TROVA_ATM', 'selezionaLabel') });
    }

    this.busyCard = false;
    this.atmRegionName = provinceArray[0].description;
  }

  /**
   * Used to populate data for region dropdown
   */
  fillRegionList() {
    this.regionList = [];
    this.busyCard = true;
    this.serviceErrorMessage = undefined;
    this.trovaAtmService.fillRegionList().subscribe(
      (data) => {
        this.regioniProvinceResponse = data;
        Object.keys(data.data.regions).forEach((key) => {
          if(this.regionList.length === 0) {
            this.regionList.unshift({ value: "0000000", label: this.labels.getLabel('TROVA_ATM', 'selezionaLabel').toLowerCase(), name: null });
          }
          var region = Utils.formatOptionValue(data.data.regions[key].description.toLowerCase());
          this.regionList.push({
            value: data.data.regions[key].code, label: region, name: data.data.regions[key].description
          });

        });
        
        this.ngZone.run(() => {
          const app = this.regionList;
          this.regionList = app;
        });

        this.busyCard = false;
      }, 
      (err: ResponseError) => {
        this.serviceErrorMessage = err.friendlyMessage;
        this.busyCard = false;
      }
    );
  }

  provinceSelected(data: any, label: any, isSearchByCurrentPosition = false) {
    this.provinceSelectLabel = "";
    this.printProvince = label
    if(!isSearchByCurrentPosition) {
      this.searchAtm();
    }
  }

  /**
   * Agency search based on region selected
   */
  searchAgencies() {
    const params = {
      "region": this.agencyRegion
    };

    if(this.agencyRegion) {
      this.busyCard = true;
      this.serviceErrorMessage = undefined;
      this.trovaAtmService.searchAgency(params).subscribe(
        (response) => {
          this.agencyList = response.data.agencyList;
          this.totalAgenciesFound = this.agencyList.length;
          this.showAtmMarkers = false;
          this.showAtmList = false;
          this.showAgencyMarkers = true;
          this.showAgencyList = false;
          this.showAgencyGrid = true;
          this.tsHistoryTransaction = this.agencyList;
          this.setPage(1, this.agencyList);
          this.setGridPage(1, this.agencyList);
          this.busyCard = false;
        }, 
        (err: ResponseError) => {
          this.busyCard = false;
          this.serviceErrorMessage = err.friendlyMessage;
        }
      );
    }
    else {
      this.agencyForm.form.controls['agencyRegion'].markAsDirty();
      this.agencyForm.form.controls['agencyRegion'].markAsTouched();
    }
  }

  /**
   * Filtro per ATM attivi richiesto su endAtmInstallationDate: se uguale a 9999-12-31, allora l'ATM è attivo
   */
  filterAtmByInstallationDate(atmList) {
    var date = new Date("9999-12-31");
    return atmList.filter(atm => {
      if(atm.endAtmInstallationDate) {
        var installationDateAtm = new Date(atm.endAtmInstallationDate);

        if(installationDateAtm.toDateString() === date.toDateString()) {
          return atm;
        }
      }
      return []
    });

  }

  settingAtmResponse(atmList) {
    this.atmList = atmList;

    if(this.atmList && this.atmList.length===0) {
      this.listATMEmpty = true;
      this.busyCard = false;
      var atmEmpty = {
        "zipCode": "none",
        "placeDescription": "Lista vuota",
      };
      this.atmList.push(atmEmpty);
      this.totalATMsFound = 0;
    }
    else {
      // filtraggio per ATM attivi
      this.listATMEmpty = false;
      this.atmList = this.filterAtmByInstallationDate(this.atmList);
      this.filteredAtmList = this.atmList;
      // add services to ATM
      this.atmList.forEach(atm => {
        atm.services = [
          this.labels.getLabel('TROVA_ATM', 'service1Label'),
          this.labels.getLabel('TROVA_ATM', 'service2Label'),
          this.labels.getLabel('TROVA_ATM', 'service3Label'),
          this.labels.getLabel('TROVA_ATM', 'service4Label'),
          this.labels.getLabel('TROVA_ATM', 'service5Label'),
          this.labels.getLabel('TROVA_ATM', 'service6Label')
        ];
        // if multifuncionalTypeFlag s true, add "Versamento banconote e assegni" service. HERE
        if(atm.multifuncionalTypeFlag === "1") {
          atm.services.push(this.labels.getLabel('TROVA_ATM', 'service7Label'));
        }
      });

      this.totalATMsFound = this.atmList.length;
      this.showAgencyMarkers = false;
      this.showAgencyGrid = false;
      this.showAgencyList = false;
      this.showAtmMarkers = true;
      if(this.showAtmList === undefined && this.showAtmGrid === undefined) {
        this.showAtmList = true;
        this.showAtmGrid = false;
      }
      this.tsHistoryTransaction = this.atmList;
      this.setPage(1, this.atmList);
      this.setGridPage(1, this.atmList);
      this.busyCard = false;

      // center map in the average position of all markers
      // http://www.geomidpoint.com/calculation.html
      // if (this.atmList.length>0) {
      //   // set 0 lat & long necessary => https://github.com/SebastianM/angular-google-maps/issues/1186
      //   this.latitude = 0;
      //   this.longitude = 0;

      //   will contain the x y z values of the cartesian average point of atms
      //   let avg_point = [0, 0, 0];

      //   this.atmList.forEach(element => {
      //     if(element.latitudeDecimalDegrees != 0 && element.longitudeDecimalDegrees != 0) {
      //       // decimal to cartesian
      //       let x = Math.cos(element.latitudeDecimalDegrees* (Math.PI / 180)) * Math.cos(element.longitudeDecimalDegrees* (Math.PI / 180));
      //       let y = Math.cos(element.latitudeDecimalDegrees* (Math.PI / 180)) * Math.sin(element.longitudeDecimalDegrees* (Math.PI / 180));
      //       let z = Math.sin(element.latitudeDecimalDegrees* (Math.PI / 180));

      //       // sum each coordinate
      //       avg_point = [avg_point[0]+x, avg_point[1]+y, avg_point[2]+z];
      //     }
      //   });

      //    make average for each coordinate
      //   avg_point = [avg_point[0]/this.atmList.length, avg_point[1]/this.atmList.length, avg_point[2]/this.atmList.length];

      //   // setTimeout necessary => https://github.com/SebastianM/angular-google-maps/issues/1186
      //   setTimeout(()=>{
      //     this.zoomLevel = 11;
      //     //            this.latitude =  this.atmList[0].latitudeDecimalDegrees;
      //     //            this.longitude = this.atmList[0].longitudeDecimalDegrees;

      //     // convert coordinates back to decimal deg
      //     this.longitude = Math.atan2(avg_point[1], avg_point[0]) * (180 / Math.PI);
      //     const hyp = Math.sqrt(avg_point[0] * avg_point[0] + avg_point[1] * avg_point[1])
      //     this.latitude =  Math.atan2(avg_point[2], hyp) * (180 / Math.PI);
      //   });

      // }

      this.fitBoundsToMarkers();
      this.latlngBounds = new window['google'].maps.LatLngBounds();
      this.atmList.forEach((atm) => {
        if(atm.latitudeDecimalDegrees !== 0 && atm.longitudeDecimalDegrees !== 0) {
          this.latlngBounds.extend(new window['google'].maps.LatLng(atm.latitudeDecimalDegrees, atm.longitudeDecimalDegrees))
        }
      })
    }

  }

  fitBoundsToMarkers() {
    if (!this.mappa || this.atmList.length === 0) {
      return
    }
    const bounds = new google.maps.LatLngBounds();
    this.atmList.forEach(atm => {
      bounds.extend(new google.maps.LatLng(atm.latitudeDecimalDegrees,atm.longitudeDecimalDegrees));
    });
    this.mappa.googleMap?.fitBounds(bounds);
  }


  /**
   * ATM search based on region and province selected
   */
  searchAtm() {
    this.atmRegion = Utils.formatOptionValue(this.atmRegion); //document.querySelectorAll('input.mdl-textfield__input')[0].value
    this.atmProvince = Utils.formatOptionValue(this.atmProvince);

    const params = {
      "latitude": '1',
      "longitude": '1',
      "province": this.atmProvince
    };

    if (this.atmProvince && this.atmRegion) {
      this.busyCard = true;
      this.serviceErrorMessage = undefined;
      this.trovaAtmService.searchAtm(params).subscribe(
        (res) => {
          // Filtro su addressDescription - Mantis 368905: Richiesta A. Paci (mail 02/12/2019)
          const filteredArr = res.data.atm.reduce((acc, curr) => {
            const obj = acc.find(({ addressDescription }) => curr.addressDescription===addressDescription);

            // INC000000232924: se true allora mostra la prima occorrenza con multifuncionalTypeFlag a 1
            if(!obj) {
              acc.push(curr);
            }
            else if(curr.multifuncionalTypeFlag==="1" && obj.multifuncionalTypeFlag!=="1") {
              acc = [...acc.filter(el => el !== obj), curr]
            }

            return acc;

          }, []);

          // CR 453
          this.postMessageFilterChange(this.atmRegionName, this.printProvince);

          // BCD-648
          const eventData = {
            "region": this.atmRegionName,
            "province": this.printProvince
          };
          this.cmsService.trackNEW("ricerca_atm", eventData);

          this.settingAtmResponse(filteredArr);
        }, 
        (err: ResponseError) => {
          this.busyCard = false;
          this.serviceErrorMessage = err.friendlyMessage;
        }
      );
    }
    else {
      this.atmForm.form.controls['atmProvince'].markAsDirty();
      this.atmForm.form.controls['atmProvince'].markAsTouched();
      this.atmForm.form.controls['atmRegion'].markAsDirty();
      this.atmForm.form.controls['atmRegion'].markAsTouched();
    }
  }

  /**
   * Agency search based on current location
   */
  searchAgenciesWithCurrentPosition() {
    if(navigator.geolocation) {
      this.busyCard = true;
      this.serviceErrorMessage = undefined;
      navigator.geolocation.getCurrentPosition((position) => {
        const params = {
          "latitude": position.coords.latitude, // "44.511330",
          "longitude": position.coords.longitude  // "11.283090"
        };

        this.trovaAtmService.searchAgencyWithCurrentPosition(params).subscribe(
          (response) => {
            this.agencyList = response.data.agencyList;
            this.totalAgenciesFound = this.agencyList.length;
            this.showAtmMarkers = false;
            this.showAtmList = false;
            this.showAgencyList = false;
            this.showAgencyMarkers = true;
            this.showAgencyGrid = true;
            this.tsHistoryTransaction = this.agencyList;
            this.setPage(1, this.agencyList);
            this.setGridPage(1, this.agencyList);
            this.busyCard = true;
            this.serviceErrorMessage = undefined;
          }, 
          (err: ResponseError) => {
            this.busyCard = false;
            this.serviceErrorMessage = err.friendlyMessage;
          }
        );
      });
    }
  }
  getProvince(addrComp) {
    // Getting the the province element in the response
    const province = addrComp.filter(elem => elem.types[0] === 'administrative_area_level_2')
    if (province && province.length > 0) {
      // Getting the province acronym from the province element
      // province = province[0].shortName;
      const shortName = province[0].shortName;
      // Update the province option based on province acronym retrieved
      if (this.provinceList) {
        const foundProvince = this.provinceList.filter(prov => prov.value === shortName)
        if (foundProvince.length > 0) {
          this.atmProvince = foundProvince[0].value;
          this.provinceSelected(this.atmProvince, foundProvince[0].label, true);
        }
      }
    }
  }
  getRegion(addrComp){
     // Getting the the region element in the response
     const region = addrComp.filter(elem => elem.types[0] === 'administrative_area_level_1')
     if (region && region.length > 0) {
       // Getting the region Name from the region element
       // region = region[0].longName;
       let longName = region[0].longName;
       // Formatting the region name
       // region = region.replace('-', ' ');
       longName = longName.replace('-', ' ');
       // Update the region option based on region name retrieved
       if (this.regionList) {
         const foundRegion = this.regionList.filter(reg => reg.label === longName);
         if (foundRegion.length > 0) {
           this.regionSelectLabel = "";
           this.atmRegion = foundRegion[0].value;
           // COMMENTO this.atmRegionName = foundRegion[0].value;

           this.oldRegion = foundRegion;
           this.fillProvinceList(this.atmRegion);
         }
       }
     }

  }
  /**
   * ATM search based on current location
   */
  searchAtmWithCurrentPosition() {
    var geoLocationOptions = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0
    };

    if("geolocation" in navigator) {
      this.busyCard = true;
      this.serviceErrorMessage = undefined;
      navigator.geolocation.getCurrentPosition(
        // success
        (position) => {
          this.regionSelectLabel = "";
          this.provinceSelectLabel = "";

          //prepare params for services calls
          const params = {
            "latitude": position.coords.latitude, // parseFloat("41.7927845"), //
            "longitude": position.coords.longitude  // // parseFloat("12.4504785")
          };

          this.busyCardReverseGeocoding = true;
          const Geocoder = new window['google'].maps.Geocoder;
          Geocoder.geocode({ 'location': { lat: params['latitude'], lng: params['longitude'] } }, (response, status) => {
            if (status === 'OK') {
              if (response[0]) {
                if (response) {
                  // address component contains info about region and province
                  const addrComp = response[0].address_components
                  this.getRegion(addrComp);
                  this.getProvince(addrComp);
                  this.geoLocatedRegion = this.atmRegion;
                  this.geoLocatedCity = this.atmProvince;

                  this.atmForm.form.controls['atmRegion'].setValue(this.geoLocatedRegion);
                  this.atmForm.form.controls['atmProvince'].setValue(this.geoLocatedCity);
                  this.busyCardReverseGeocoding = true;
                  this.regionSelectLabel = "";
                  this.provinceSelectLabel = "";

                  this.busyCardReverseGeocoding = false;
                  this.busyCard = false;
                }
              }
              else {
                window.alert('No results found');
              }
            }
            else {
              window.alert('Geocoder failed due to: ' + status);
            }
          });

          // update Region and Province option inputs in atm Tab based on position (uses Google API)
          // this.trovaAtmService.reverseGeocodingFromPosition(params).subscribe(
          //   //success reverse geocoding
          //   response => {
          //   if(response && response.results && response.results[0] && response.results[0].address_components) {
          //     // address component contains info about region and province
          //     let addrComp = response.results[0].address_components

          //     Getting the the region element in the response
          //     let region = addrComp.filter( elem => elem.types[0]==='administrative_area_level_1')
          //     if(region && region.length>0){
          //       // Getting the region Name from the region element
          //       region = region[0].longName;
          //        Formatting the region name
          //       region = region.toUpperCase().replace('-', ' ');
          //        Update the region option based on region name retrieved
          //       if(this.regionList) {
          //         let foundRegion = this.regionList.filter(reg => reg.label === region);
          //         if(foundRegion.length > 0) {
          //           this.atmRegion = foundRegion[0].value;
          //           this.fillProvinceList(this.atmRegion);
          //         }
          //       }
          //     }

          //     // Getting the the province element in the response
          //     let province = addrComp.filter( elem => elem.types[0]==='administrative_area_level_2')
          //     if(province && province.length > 0) {
          //       // Getting the province acronym from the province element
          //       province = province[0].shortName;
          //       // Update the province option based on province acronym retrieved
          //       if(this.provinceList) {
          //         let foundProvince = this.provinceList.filter(prov => prov.value===province)
          //         if(foundProvince.length > 0) {
          //           this.atmProvince = foundProvince[0].value;
          //         }
          //       }
          //     }
          //     this.busyCardReverseGeocoding = false;
          //     this.busyCard = false;
          //   }
          // },
          // // error reverse geocoding
          // (err: ResponseError) => {
          //   this.serviceErrorMessage = err.friendlyMessage;
          //   this.busyCardReverseGeocoding = false;
          //   this.busyCardATMByPosition = false;
          // });

          this.busyCardATMByPosition = true;
          this.trovaAtmService.searchAtmWithCurrentPosition(params).subscribe(
            (response) => {
              // Filtro su addressDescription - Mantis 368905: Richiesta A. Paci (mail 02/12/2019)
              const filteredArr = response.data.atm.reduce((acc, curr) => {
                const obj = acc.find(({ addressDescription }) => curr.addressDescription===addressDescription);

                // INC000000232924: se true allora mostra la prima occorrenza con multifuncionalTypeFlag a 1
                if(!obj) {
                  acc.push(curr);
                }
                else if(curr.multifuncionalTypeFlag==="1" && obj.multifuncionalTypeFlag!=="1") {
                  acc = [...acc.filter(el => el !== obj), curr]
                }

                return acc;

              }, []);

              // CR 453
              this.postMessageFilterChange(this.atmRegionName, this.printProvince);

              // BCD-648
              const eventData = {
                "region": this.atmRegionName,
                "province": this.printProvince
              };
              this.cmsService.trackNEW("ricerca_atm", eventData);

              this.settingAtmResponse(filteredArr);
            }, 
            (err: ResponseError) => {
              this.busyCardATMByPosition = false;
              this.busyCardReverseGeocoding = false;
              this.serviceErrorMessage = err.friendlyMessage;
            }
          );

          this.busyCard = false;
          this.busyCardReverseGeocoding = false;
          this.busyCardATMByPosition = false;
        },
        (err) => {
          this.busyCard = false;
          this.busyCardReverseGeocoding = false;
          this.busyCardATMByPosition = false;
          switch(err.code) {
            case 1: this.serviceErrorMessage="Sono richiesti i permessi per accedere alla posizione."; 
            break;
            case 2: this.serviceErrorMessage="Errore nel recupero della posizione"; 
            break;
            case 3: this.serviceErrorMessage="Il recupero della posizione ha superato il tempo previsto"; 
            break;
            default: this.serviceErrorMessage=err.message; 
            break;
          }
        },
        // Options
        geoLocationOptions);
    }
    else {
      this.serviceErrorMessage = "Geolocation is not supported by this browser.";
    }
  }

  /**
   * Used to show the details of the agency on click of detail button in the search results
   * displays a zoomed single marker on the agency in map
   * @param agency - object containing details of the agency selected
   */
  getAgencyDetail(agency) {
    this.agencyDetail = agency;
    this.showAgencyDetail = true;
    this.showAgencyMarkers = false;
    this.zoomLevel = 11;
    this.latitude = this.agencyDetail.latitude;
    this.longitude = this.agencyDetail.longitude;
  }

  /**
   * Invoked when back button is clicked in detail screen
   * displays the tabs with agency list and markers
   */
  backToTabsAgency() {
    this.showAgencyDetail = false;
    this.showAgencyMarkers = true;
    this.zoomLevel = 7;
    this.latitude = 43.769562;
    this.longitude = 11.255814;
  }

  /**
   * Used to specifically point at the selected Agency in google maps
   */
  goToGoogleMapsAgency(agencyDetail) {
    window.open(
      `http://www.google.com/maps/place/ 
      ${agencyDetail.latitudeDecimalDegrees},
      ${agencyDetail.longitudeDecimalDegrees}/@
      ${agencyDetail.latitudeDecimalDegrees},
      ${agencyDetail.longitudeDecimalDegrees},15z`, "_blank");
  }

  /**
   * Used to specifically point at the selected ATM/ in google maps
   */
  goToGoogleMapsAtm(atmDetail) {
    window.open(
      `http://www.google.com/maps/place/
      ${atmDetail.latitudeDecimalDegrees},
      ${atmDetail.longitudeDecimalDegrees}/@
      ${atmDetail.latitudeDecimalDegrees},
      ${atmDetail.longitudeDecimalDegrees},15z`
      , "_blank");
  }

  onMapReady(mappa : google.maps.Map){
    
  }


  mapReady(map) {
    this.map = map;
  }

  /**
   * Used to show the details of the ATM on click of detail button in the search results
   * displays a zoomed single marker on the ATM in map
   * @param atm - object containing details of the ATM selected
   */
  getAtmDetail(atm, target) {
    //aggiungere (solo desktop) del bottom per non decentrare il pannello atmDetail
    this.bordoDetailAtm(true);

    target.scrollIntoView({ behavior: "smooth" });
    this.atmDetail = atm;
    this.showAtmDetail = true;
    this.showAtmMarkers = false;
    this.zoomLevel = 19;
    this.mappa.googleMap.setCenter({ lat: atm.latitudeDecimalDegrees, lng: atm.longitudeDecimalDegrees });
    //COMMENTO this.latitude = this.atmDetail.latitudeDecimalDegrees;
    //COMMENTO this.longitude = this.atmDetail.longitudeDecimalDegrees - 0.05;
  }

  bordoDetailAtm(aggiungereBordo: boolean) {
    if(!window.matchMedia('screen and (max-width: 768px)').matches) {
      this.cardRicerca = this.ref.nativeElement.querySelector('.cardSearch');

      //COMMENTO var allServicesInAtmDetail = this.atmDetail && this.atmDetail.services.length > 5 ? 'bottomDetailCardMax' : 'bottomDetailCard';
      if(aggiungereBordo) {
        this.cardRicerca.classList.add('bottomDetailCard');
      }
      else {
        //COMMENTO this.cardRicerca.classList.remove('bottomDetailCardMax');
        this.cardRicerca.classList.remove('bottomDetailCard');
      }
    }
  }

  /**
   * Invoked when back button is clicked in detail screen
   * displays the tabs with atm list and markers
   */
  backToTabsAtm() {
    //togliere (solo desktop) del bottom per non decentrare il pannello atmDetail
    this.bordoDetailAtm(false);

    this.showAtmDetail = false;
    this.showAtmMarkers = true;
    this.fitBoundsToMarkers();
    this.latlngBounds = new window['google'].maps.LatLngBounds();
    this.atmList.forEach((atm) => {
      if(atm.latitudeDecimalDegrees !== 0 && atm.longitudeDecimalDegrees !== 0) {
        this.latlngBounds.extend(new window['google'].maps.LatLng(atm.latitudeDecimalDegrees, atm.longitudeDecimalDegrees))
      }
    })
  }

  /**
   * FOR GRID - 12 elements per page
   * Pagination method
   * Used to set page number and page's contents
   */
  setGridPage(page: number, data?: any[]) {
    const who = data ? data : this.tsHistoryTransaction;
    this.paginationContext = who;
    if(page<1 || page>this.pager.totalPages) {
      return;
    }
    // Get pager object from service
    this.pager.getPager(who.length, page);
    // Get current page of items
    this.displayGrid = who.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  /**
   * For List - Regular 10 elements per page
   * Pagination method
   * Used to set page number and page's contents
   */
  setPage(page: number, data?: any[]) {
    const who = data ? data : this.tsHistoryTransaction;
    this.paginationContext = who;
    if (page<1 || page>this.pager.totalPages) {
      return;
    }
    // Get pager object from service
    this.pager.getPager(who.length, page);
    // Get current page of items
    this.displayList = who.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  openButtonModal() {
    this.modalService.open('atmFilter');
  }

  /**
   * Invoked when modal dialog needs to be closed
   * @param formData - modal ID
   */
  closeButtonModal(formData?: any) {
    this.modalService.close('atmFilter');
  }

  /**
   * Invoked when filter button is clicked
   */
  filterATMList() {
    // get list of services selected in UI
    const servicesSelected = this.services.filter(service => service.filter);
    this.filteredAtmList = [];

    if(servicesSelected.length > 0) {
      // filtering atm list by service
      this.filteredAtmList = this.atmList.filter(atm => {
        let acceptAtm = true;
        servicesSelected.forEach(service => {
          acceptAtm = acceptAtm && atm.services.includes(service.label);
        });
        return acceptAtm;
      });

    } else {
      this.filteredAtmList = this.atmList;
    }

    this.totalATMsFound = this.filteredAtmList.length;

    if(this.showAtmList) {
      this.setPage(1, this.filteredAtmList);
    }
    else {
      this.setGridPage(1, this.filteredAtmList);
    }
  }

  /**
   * Invoked whenever a checkbox is clicked (checked or unchecked - both)
   */
  onCheckboxToggle(data) {
    this.services.filter(service => service.label === data.label)[0].filter = !data.filter;
  }

  /**
   * Switch to List View
   */
  switchToAgencyList() {
    this.showAgencyGrid = true;
    this.showAgencyList = false;
    this.setGridPage(1, this.agencyList);
  }

  /**
   * Switch to grid view
   */
  switchToAgencyGrid() {
    this.showAgencyGrid = false;
    this.showAgencyList = true;
    this.setPage(1, this.agencyList);
  }

  /**
   * Switch to List View
   */
  switchToAtmList() {
    this.showAtmGrid = true;
    this.showAtmList = false;
    this.filterATMList();
  }

  /**
   * Switch to grid view
   */
  switchToAtmGrid() {
    this.showAtmGrid = false;
    this.showAtmList = true;
    this.filterATMList();
  }

  postMessageFilterChange(regionCode, provinceCode) {
    // SEND
    var parentDoveSiamo = window.parent;

    // dati da passare al parent
    var data = {
      'action': 'filterChange',
      'data': {
        'regionCode': regionCode,
        'provinceCode': provinceCode
      }
    }

    parentDoveSiamo.postMessage(data, location.origin);
  }

  ngOnDestroy() {
    window.removeEventListener('message', this.closeSelectFromParent);
  }

}
